import { useFormik } from "formik";
import {
  addCommunity,
  editCommunity,
} from "../../../../API/store/actions/admin/communitiesAction";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../../../auth/formikValidation";
import TextInput from "../../../sharedComponents/inputs/textInput";
import Lang from "../../../../userPreferences/staticWords";
import Switch from "../../../sharedComponents/switch/switch";
import Button from "../../../sharedComponents/buttons/button";
import { filterObj, objToFormData } from "../../../../algorithms";
import TextArea from "../../../sharedComponents/textarea/textArea";
import FileInput from "../../../sharedComponents/inputs/fileInput";
import { MemberListItem } from "../../../../algorithms/listsAlogrithms";
import { useEffect, useState } from "react";
import { loadLookups, loadSectors } from "../../../../API/services/utilities";
import { resolver } from "../../../../API/middlewares/resolveRequests";
import { customStyle, styleStart } from "../../../../algorithms/styleDirection";
import { paths } from "../../../../paths/paths";
import { useDispatch } from "react-redux";
import DropDownList from "../../../sharedComponents/dropdown/dropdown";
const AddCommunityForm = ({
  userToken,
  isEdit,
  modalVisible,
  setModalVisible,
  data,
}) => {
  const dispatch = useDispatch();

  const [researchAreas, setResearchAreas] = useState(null);
  const [sectors, setSectors] = useState(null);
  useEffect(() => {
    resolver(loadLookups, setResearchAreas, 12, userToken);
    resolver(loadSectors, setSectors, userToken);
  }, []);
  const [disable, setDisable] = useState(false);
  console.log(sectors);
  const submit = async (values) => {
    values.id = modalVisible?.helperData?.id;

    const newObj = filterObj(values);
    const formBody = objToFormData(newObj);
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res;
    res = isEdit
      ? await editCommunity(formBody, userToken)
      : await addCommunity(formBody, userToken);
    if (res?.status <= 206) {
      dispatch({ type: "RELOAD" });
      setModalVisible({
        ...modalVisible,
        editCommunity: false,
        helperData: null,
        addCommunity: false,
      });
      setDisable(false);
    } else {
      setDisable(false);
    }
    // Logo: null,
    // CoverPhoto: null,
    // ResearchAreas: null,
  };
  const formik = useFormik(
    formikSetup(
      initialValues,
      isEdit ? data ?? {} : {},
      validationSchema,
      "addCommunity",
      submit
    )
  );
  const {
    errors,
    touched,
    handleSubmit,
    handleChange,
    setFieldValue,
    values,
  } = formik;

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="d-flex flex-wrap justify-content-center align-content-center mb-3 h-100">
          {/* <div className="col-5 mx-3  d-flex justify-content-center align-items-center flex-column">
            <FileInput
              iconPrefix={"far"}
              iconName={"user-circle"}
              iconColor={"white"}
              name={"user-circle"}
              fileName={" "}
              source={
                values.Logo
                  ? `${paths.CommunityLogo}${modalVisible?.helperData?.id}/${values.Logo}`
                  : ""
              }
              src={values.LogoFile}
              backgroundSize={95}
              backgroundColor={"#60606085"}
              size={95}
              uploaded={values.LogoFile ? true : false}
              uploadedMessage={values.LogoFile ? "تغيير" : ""}
              onChange={(e) => {
                setFieldValue("LogoFile", e.target.files[0]);
              }}
              error={formikValidation(touched, errors, "LogoFile")}
            />
            صورة الشعار
          </div>
          <div className="col-5 mx-3  d-flex justify-content-center align-items-center flex-column">
            <FileInput
              iconPrefix={"far"}
              iconName={"user-circle"}
              iconColor={"white"}
              name={"user-circle"}
              fileName={" "}
              src={values.CoverPhotoFile}
              source={
                values.CoverPhoto
                  ? `${paths.CommunityCoverPhoto}${modalVisible?.helperData?.id}/${values.CoverPhoto}`
                  : ""
              }
              backgroundSize={95}
              backgroundColor={"#60606085"}
              size={95}
              uploaded={values.CoverPhotoFile ? true : false}
              uploadedMessage={values.CoverPhotoFile ? "تغيير" : ""}
              onChange={(e) => {
                setFieldValue("CoverPhotoFile", e.target.files[0]);
              }}
              error={formikValidation(touched, errors, "CoverPhotoFile")}
            />
            صورة الخلفية
          </div> */}
          <TextInput
            type={"text"}
            value={values.Name_A}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "Name_A")}
            name={"Name_A"}
            placeholder={"الاسم بالعربي" + "*"}
            containerStyle={"col-12  col-md-5 mx-1 mt-4"}
          ></TextInput>
          <TextInput
            style={{ textAlign: "left" }}
            type={"text"}
            direction={"ltr"}
            value={values.Name_E}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "Name_E")}
            name={"Name_E"}
            placeholder={"الاسم بالانجليزية" + "*"}
            containerStyle={"col-12  col-md-5 mx-1 mt-4"}
          ></TextInput>
          <TextArea
            value={values.Description_A}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "Description_A")}
            name={"Description_A"}
            placeholder={"الوصف بالعربي" + "*"}
            containerStyle={"col-12  col-md-10 mx-3 mt-4"}
          ></TextArea>
          <TextArea
            value={values.Description_E}
            style={{ textAlign: "left" }}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "Description_E")}
            name={"Description_E"}
            placeholder={"الوصف بالانجليزية"}
            containerStyle={"col-12  col-md-10 mx-3 mt-4"}
          ></TextArea>

          {/* {researchAreas ? (
            <div className={"d-flex flex-column my-2 col-10 mt-4"}>
              <div className={`d-flex px-3 mb-3 ${styleStart("m", 2)}`}>
                <p className="my-0">{Lang.proessionalAreaOfResearch}</p>
              </div>

              <div
                className={`d-flex flex-column  px-3 py-2 mx-1 ${customStyle(
                  "TitleCard"
                )}`}
                style={{
                  height: "fit-content",
                  maxHeight: 250,
                }}
              >
                <div className="d-flex mb-3"></div>

                <div className="d-flex flex-column scroll py-3">
                  {researchAreas?.data?.map((item, index) => {
                    let memberPhoto = `url("/assets/images/icons/research.png")`;

                    return (
                      <MemberListItem
                        key={index}
                        id={item.id}
                        photo={memberPhoto}
                        index={index}
                        name={item.description}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const value = e.target.value;
                          if (checked) {
                            setFieldValue("ResearchAreas", [
                              ...values?.ResearchAreas,
                              parseInt(value),
                            ]);
                          } else {
                            setFieldValue(
                              "ResearchAreas",
                              [...values?.ResearchAreas].filter(
                                (item) => item != parseInt(value)
                              )
                            );
                          }
                        }}
                        values={values?.ResearchAreas?.filter(
                          (i) => i == item.id
                        )}
                        length={researchAreas?.data?.length - index}
                        checked={true}
                        idChar={"B"}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            <>LOADING</>
          )} */}

          <div className="col-md-10 col-12 mt-4 flex-wrap d-flex">
            {/* <DropDownList
              placeholder={"القطاعات"}
              border={true}
              containerStyle={`col-12 col-lg-4`}
              dataSource={sectors?.data?.sectorLkp}
              value={values.SectorId}
              change={(e) => {
                setFieldValue("SectorId", e.value);
              }}
              errorMessage={formikValidation(touched, errors, "SectorId")}
            /> */}
            <TextInput
              type={"number"}
              value={values.SortIndex}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "SortIndex")}
              name={"SortIndex"}
              placeholder={"الترتيب"}
              containerStyle={"col-12 col-lg-4 pe-lg-2 mt-lg-0 my-4"}
              min={0}
            ></TextInput>
            <div className="col-6 col-lg-2 d-flex align-items-center justify-content-lg-center">
              <div className="mx-2">مفعل</div>
              <Switch
                checked={values.Active}
                name={"Active"}
                onClick={() => {
                  setFieldValue("Active", !!!values.Active);
                }}
              />
            </div>
            <div className="col-6 col-lg-2 d-flex align-items-center justify-content-lg-center">
              <div className="mx-2">مميز</div>
              <Switch
                checked={values.Focus}
                name={"Focus"}
                onClick={() => {
                  setFieldValue("Focus", !!!values.Focus);
                }}
              />
            </div>
          </div>
          <Button
            containerStyle={"col-4 mx-3 mt-4"}
            type={"submit"}
            buttonStyleType="solid"
            disable={disable}
            content={disable ? Lang.saving : Lang.save}
          />
        </div>
      </form>
    </>
  );
};

export default AddCommunityForm;
